import { WarningCircleIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import type { FavoriteFailure } from '../model/useFavoriteToggle';

import styles from './FavoriteNotice.module.css';

/**
 * Сбой отметки (FE-586): сердечко уже вернулось назад, а здесь сказано почему
 * и что делать. Текст, а не только цвет; `role="alert"` — сообщение о событии.
 */
export function FavoriteNotice({ failed, name }: { failed: FavoriteFailure; name: string }) {
  const { t } = useTranslation();

  return (
    <p className={styles.notice} role="alert">
      <WarningCircleIcon size={16} weight="fill" aria-hidden="true" />
      <span>{t(`showcase.favorite.error.${failed}`, { name })}</span>
    </p>
  );
}
